import ajaxBlocks from '../util/ajaxBlocks';
import appState from '../util/appState';
import common from '../routes/common';
import moment from 'moment';
import notie from 'notie';

const jobs = {
  init() {
    // JavaScript to be fired on the jobs page

    // Init ajaxBlocks
    ajaxBlocks.init();

    // Initial state for active job + job totals
    jobs.updateActiveJob();
    jobs.updateJobTotal();
    jobs.updateHandlers();

    // If no active job, select first one
    let activeJob = document.querySelector('.jobs.active');
    if (!activeJob) {
      let firstJob = document.querySelector('.ajaxblock.jobs .job-status:not(.paid)');
      if (firstJob) {
        jobs.getJobDetails(firstJob.parentElement.parentElement, { noscroll: true });
      }
    }

    // Return key handler:
    // - opens job if focused
    // - opens ajaxblock if focused
    Mousetrap.bind('return', e => {
      let focused = document.activeElement;
      // todo: make sure no forms are open?
      if (focused && focused.classList.contains('ajaxblock') && focused.classList.contains('jobs')) {
        jobs.getJobDetails(focused);
      } else if (focused && focused.classList.contains('ajaxblock') && focused.classList.contains('items')) {
        ajaxBlocks.editClick(e, focused);
      }
    }).bind('n', e => {
      // N => add new item
      let addItem = document.querySelector('.addItem[data-type="items"]');
      ajaxBlocks.addClick(e, addItem);
    });

    // Toggle paid jobs showing
    document.querySelectorAll('.clients-list .client').forEach(client => {
      let toggleJobList = client.querySelector('.toggleJobList');
      if (toggleJobList) {
        toggleJobList.addEventListener('click', e => {
          if (!client.getAttribute('data-show-jobs') || client.getAttribute('data-show-jobs') == '') {
            client.setAttribute('data-show-jobs', 'paid');
          } else {
            client.setAttribute('data-show-jobs', '');
          }
        });
      }
    });

    // Watch for browser history state change, supporting back/next
    window.addEventListener('popstate', jobs.checkUrl);

    // CSV upload button
    document.addEventListener('click', e => {
      if (e.target.matches('.import-csv-go')) {
        e.preventDefault();
        let form = e.target.closest('form');
        let fileInput = form.querySelector('input[type=file]');
        fileInput.click();
        fileInput.addEventListener('change', e => {
          const formData = new FormData(form);
          appState.requestInProgress = true;
          fetch(form.getAttribute('action'), {
              method: 'POST',
              body: formData,
            })
            .then(response => response.json())
            .then(data => {
              // Clear out file input
              fileInput.value = '';
              appState.requestInProgress = false;
              if (data.status == 1) {
                // Show success stats & reload page when clicking OK to show imported items
                notie.force({
                  type: 'success',
                  text: 'Success! ' + data.log.stats.message,
                  buttonText: 'OK',
                  callback: () => location.reload()
                });
              } else {
                // Something went wrong
                notie.alert({
                  type: 'error',
                  text: 'Oh no! ' + data.log.error[0]
                });
              }
            });
        });
      }
    });

    // Load job details when clicking on job title in clients list
    document.addEventListener('click', e => {
      if (e.target.matches('.clients-list .jobs .title') || e.target.matches('.clients-list .jobs .title span')) {
        e.preventDefault();
        let jobsLink = e.target.closest('.clients-list .jobs .title');
        let ajaxblockEl = e.target.closest('.ajaxblock');
        history.pushState(null, null, jobsLink.href);
        jobs.getJobDetails(ajaxblockEl);
      }
    });

    // Watch for custom "save-ajaxblock-form" event
    window.addEventListener('save-ajaxblock', e => {
      // If saving job item, update job detail totals
      if (e.detail.type == 'items') {
        jobs.updateJobTotal();
      }

      // If saving job, check if job-detail is open, and update title if so
      if (e.detail.type == 'jobs') {
        let jobDetailsEl = document.querySelector('.job-details[data-id="' + e.detail.id + '"]');
        if (jobDetailsEl) {
          let newTitle = document.querySelector('.jobs[data-id="' + e.detail.id + '"] .title').textContent;
          jobDetailsEl.querySelector('.header .title').textContent = newTitle;
        }
      }
    });

    // Watch for custom "delete-ajaxblock" event
    window.addEventListener('delete-ajaxblock', e => {
      // If deleting job item, update job detail totals
      if (e.detail.type == 'items') {
        jobs.updateJobTotal();
      }

      // If deleting job, check if job is open, & clear it out
      if (e.detail.type == 'jobs') {
        let jobDetailsEl = document.querySelector('.job-details[data-id="' + e.detail.id + '"]');
        if (jobDetailsEl) {
          jobDetailsEl.setAttribute('data-id', '');
          jobDetailsEl.innerHTML = '';
        }
      }
    });

  },

  // Get job details when clicking on job title in clients sidebar
  getJobDetails(ajaxblockEl, opts) {
    appState.requestInProgress = true;
    jobs.updateActiveJob();
    let id = ajaxblockEl.getAttribute('data-id');
    $.getJSON('/inc/ajaxBlocks.php', {
      'action': 'get-entry',
      'type': 'jobs',
      'id': id
    }).done(response => {
      if (response.status === 1) {
        appState.requestInProgress = false;
        document.querySelectorAll('.clients-list .jobs').forEach(job => {
          job.classList.remove('active');
        });
        ajaxblockEl.classList.add('active');
        let jobDetailsEl = document.querySelector('.job-details');
        jobDetailsEl.innerHTML = response.html;
        jobDetailsEl.setAttribute('data-id', id);
        jobs.updateJobTotal();
        jobs.updateHandlers();

        // Scroll to job?
        if (!opts || !opts.noscroll) {
          jobDetailsEl.scrollIntoView();
        }

        // Init color hovers on freshly-added buttons
        common.hovers();
      } else {
        ajaxBlocks.handleError(response.msg);
      }
    });
  },

  // Save job title
  saveTitle() {
    let jobTitle = document.querySelector('.job-details .header .title');
    // Trim title
    let jobTitleText = jobTitle.innerText.trim();
    jobTitle.innerText = jobTitleText;
    let id = document.querySelector('.job-details').getAttribute('data-id');
    // Update db
    $.getJSON('/inc/ajaxBlocks.php', {
      'action': 'save-job-title',
      'title': jobTitleText,
      'id': id
    }).done(response => {
      if (response.status === 1) {
        // Update sidebar title to match
        document.querySelector(`.clients-list div[data-type="jobs"][data-id="${id}"] span`).innerText = jobTitleText;
      }
    });
  },

  // Update js handlers for active job
  updateHandlers() {
    // Single job title is editable via contentEditable=true
    let jobTitle = document.querySelector('.job-details .header .title');
    if (jobTitle) {
      // If hitting return, blur title
      Mousetrap(jobTitle).bind('return', e => {
        e.preventDefault();
        jobTitle.blur();
      });
      // On blur, save job title
      jobTitle.addEventListener('blur', e => {
        jobs.saveTitle();
      });
    }
  },

  // Update the active job in client sidebar
  updateActiveJob() {
    // Remove active class on all jobs
    document.querySelectorAll('.clients-list .jobs').forEach(el => {
      el.classList.remove('active');
    });
    // See if we can find the active job based on URL
    let link = document.querySelector(`.clients-list .jobs a[href="${location.pathname}"]`);
    if (link) {
      let ajaxblockEl = link.closest('.ajaxblock');
      ajaxblockEl.classList.add('active');
    }
  },

  // Check the URL after popstate to update state
  checkUrl() {
    if (location.pathname == '/jobs' || location.pathname == '/jobs/') {
      // Homepage? Just clear out main content area
      document.querySelector('.job-details').innerHTML = '';
    } else {
      // Is a job active?
      let link = document.querySelector(`.clients-list .jobs a[href="${location.pathname}"]`);
      if (link) {
        let ajaxblockEl = link.closest('.ajaxblock');
        jobs.getJobDetails(ajaxblockEl);
      }
    }
  },

  // Update cost + time totals for job in header
  updateJobTotal() {
    let header = document.querySelector('.job-details .header');
    if (header) {
      let costTotal = 0;
      let timeTotal = 0;
      document.querySelectorAll('.job-details .items').forEach(item => {
        timeTotal += parseInt(item.querySelector('.time').getAttribute('data-time'));
        costTotal += parseFloat(item.querySelector('.cost').textContent.replace(/[^0-9\.]/g, ''));
      });
      header.querySelector('.job-time i').textContent = jobs.formatTime(timeTotal);
      header.querySelector('.job-cost i').textContent = costTotal.toFixed(2);
    }
  },

  // Format minutes into HH:MM
  formatTime(mins) {
    let h = Math.floor(mins / 60);
    let m = mins % 60;
    h = h < 10 ? '0' + h : h;
    m = m < 10 ? '0' + m : m;
    return `${h}:${m}`;
  },

  finalize() {
    // JavaScript to be fired on the jobs page, after the init JS
  },
};

export default jobs
